function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var NaranjaPaymentSvg = function NaranjaPaymentSvg(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 36 24"
  }, props), React.createElement("defs", null, React.createElement("linearGradient", {
    x1: "29.752%",
    y1: "100%",
    x2: "58.907%",
    y2: "20.558%",
    id: "naranja-payment_svg__a"
  }, React.createElement("stop", {
    stopColor: "#FFF",
    offset: "0%"
  }), React.createElement("stop", {
    stopColor: "#F5CAB9",
    offset: "100%"
  }))), React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, React.createElement("rect", {
    fill: "#FF6602",
    width: 36,
    height: 24,
    rx: 2
  }), React.createElement("g", {
    fillRule: "nonzero"
  }, React.createElement("path", {
    d: "M0 12V9.176c2.321-.003 4.202-1.903 4.204-4.247V3 1L7 2v2.929C7 8.827 3.86 12 0 12z",
    fill: "url(#naranja-payment_svg__a)",
    transform: "translate(11 4)"
  }), React.createElement("path", {
    d: "M23.324 4c.73 0 1.323.63 1.323 1.407v11.789c.112.37.063.775-.142 1.115a1.424 1.424 0 0 1-.563.527 1.262 1.262 0 0 1-.618.162h-.047a1.44 1.44 0 0 1-1.26-.74L15.172 6.08a1.39 1.39 0 0 1 .038-1.407c.268-.43.748-.685 1.259-.671.51.013.975.293 1.22.736l4.309 7.673L22 5.407C22 4.63 22.593 4 23.324 4z",
    fill: "#FFF"
  }))));
};

NaranjaPaymentSvg.displayName = "NaranjaPaymentSvg";
export default NaranjaPaymentSvg;